<script setup>
import { PermissionNames } from "~/configs/permission_names";
import { useCustomerProfileStore } from "~/stores/customerProfileStore";

const props = defineProps({
  orgId: {
    type: Number,
    required: false,
  },
  isFromLead: {
    type: Boolean,
    default: false,
  },
  isFromOpp: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["created"]);

const profileStore = useCustomerProfileStore();
const handleCloseDialog = () => {
  profileStore.toggleProfileCreateModal();
};
</script>
<template>
  <div>
    <div
      v-if="isUserPermitted(PermissionNames.PROFILE_CREATE)"
      class="text-light-purple underline-light-purple- underline text-xs w-full flex justify-end dark:text-light-purple-bar"
    >
      <el-tooltip content="Add Profile" placement="top">
        <span
          class="cursor-pointer"
          @click.prevent="profileStore.toggleProfileCreateModal"
        >
          <Svgs
            name="plus"
            class="w-5 h-5 text-light-sec-purple dark:text-white"
            stroke-width="1.2"
          />
        </span>
      </el-tooltip>
    </div>
    <el-dialog
      v-model="profileStore.showProfileCreateModal"
      :befor-close="handleCloseDialog"
      :lock-scroll="false"
      :modal="false"
      :show-close="true"
      :destroy-on-close="true"
      class="rounded-lg"
      draggable
      align-center
      width="35%"
    >
      <template #header="{ titleId, titleClass }">
        <div class="my-header flex flex-col gap-1">
          <h4 :id="titleId" class="text-md" :class="titleClass">
            Create Profile
          </h4>
        </div>
      </template>
      <div class="subtext-dialog">
        <ProfileCreateForm
          :org-id="props.orgId"
          :show-edit-modal-header="false"
          :is-from-lead="props.isFromLead"
          :is-from-opp="props.isFromOpp"
          @created="(p) => emit('created', p)"
        /></div
    ></el-dialog>
  </div>
</template>
